import React from 'react';
import PropTypes from 'prop-types';
import { TargetInstancesTable } from './TargetInstancesTable';

export const TargetInstances = ({ targetInstances }) => (
  <div className="knock-react-flex input-auto">
    <div
      className="property-info-edit-field-label"
    >
      Target Instances
    </div>
    {!targetInstances || targetInstances.length === 0 ? (
      <div className="property-info-edit-field-label">No target instances</div>
    ) : (
      <TargetInstancesTable instances={targetInstances} />
    )}
  </div>
);

TargetInstances.propTypes = {
  targetInstances: PropTypes.array,
};
